/** Variabile publice CRA (prefix REACT_APP_). */

export const clarityProjectId =
  process.env.REACT_APP_CLARITY_PROJECT_ID?.trim() ?? "";
